const isProductRestockingSoon = ({ isRestockingSoon, isProductInStock }) =>
  isRestockingSoon && !isProductInStock;

const getRestockingEvar = ({ isProductInStock, isRestockingSoon }) =>
  isProductRestockingSoon({ isProductInStock, isRestockingSoon })
    ? ["eVar236=restocking soon"]
    : [];

export default getRestockingEvar;
